// extracted by mini-css-extract-plugin
export var paginationContainer = "_87-0";